import { render } from "./NoPermissionView.vue?vue&type=template&id=ce186efa&scoped=true"
import script from "./NoPermissionView.vue?vue&type=script&lang=js"
export * from "./NoPermissionView.vue?vue&type=script&lang=js"

import "./NoPermissionView.vue?vue&type=style&index=0&id=ce186efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce186efa"]])

export default __exports__